import React from 'react';
import PropTypes from 'prop-types';
import { ICONS } from 'constants/icons';

import SuccessReport from './SuccessReport';

import messages from '../ReservationFeedbackModalV2.messages';

const guidelines = [
  {
    icon: ICONS.shieldCheckSmall,
    title: messages.successGuidelineProtectionTitleUnpaid,
    description: messages.successGuidelineProtectionDescriptionUnpaid,
  },
  {
    icon: ICONS.searchGlasBlue,
    title: messages.successGuidelineInvestigationTitle,
    description: messages.successGuidelineInvestigationDescription,
  },
  {
    icon: ICONS.brokenLink,
    title: messages.successGuidelineEnforcementTitle,
    description: messages.successGuidelineEnforcementDescription,
  },
];

const UnpaidSuccessReport = ({ venueId, reservationId }) => (
  <SuccessReport
    guidelines={guidelines}
    payoutBannerIcon={ICONS.clockGreen}
    payoutBannerMessage={messages.successPayoutBannerUnpaid}
    venueId={venueId}
    reservationId={reservationId}
  />
);

UnpaidSuccessReport.propTypes = {
  venueId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  reservationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default UnpaidSuccessReport;
